
import { BrowserRouter } from 'react-router-dom';
import { Refine } from '@refinedev/core';
import { RefineKbar, RefineKbarProvider } from '@refinedev/kbar';
import routerProvider from '@refinedev/react-router-v6';
import { StagewiseToolbar } from '@stagewise/toolbar-react';
import ReactPlugin from '@stagewise-plugins/react';

import { selectedDataProvider, selectedAuthProvider } from '@/providers';
import { i18nProvider } from '@/i18n';
import { resources } from './refine-config';
import { AppRouter } from '@/router';
import SupplierModals from '@/components/suppliers/modals';
import CustomerModals from '@/components/customers/modals';
import { PricingModals } from '@/components/pricing/modals';
import ServiceModals from '@/components/services/modals';
import CategoryModals from '@/components/categories/modals';
import MaterialModals from '@/components/materials/modals';
import CuttingOrderModals from '@/components/cutting/modals';
import CuttingConfigModals from '@/components/cuttingConfigs/modals';
import WarehouseReceiptModals from '@/components/warehouseReceipts/modals';
import { ToastContainer } from '@/components/common';
import { UserProvider } from '@/contexts/UserContext';
import { RoleProvider } from '@/contexts/RoleContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { AuthenticatedWorkspace, SessionWorkspace } from '@/contexts/SessionWorkspace';

// Import i18n to initialize it
import '@/i18n';

function App() {
  const isDevelopment = import.meta.env.DEV;

  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <AuthProvider>
      <RefineKbarProvider>
        <Refine
          dataProvider={selectedDataProvider}
          authProvider={selectedAuthProvider}
          i18nProvider={i18nProvider}
          routerProvider={routerProvider}
          resources={resources}
          options={{
            syncWithLocation: true,
            warnWhenUnsavedChanges: true,
            useNewQueryKeys: true,
            projectId: "mini-erp-ui",
          }}
        >
          <SessionWorkspace>
          <UserProvider>
            <RoleProvider>
              <AppRouter />
            <RefineKbar />
            <AuthenticatedWorkspace>
            <SupplierModals />
            <CustomerModals />
            <PricingModals />
            <ServiceModals />
            <CategoryModals />
            <MaterialModals />
            <CuttingOrderModals />
            <CuttingConfigModals />
            <WarehouseReceiptModals />
            </AuthenticatedWorkspace>
            <ToastContainer />
            {isDevelopment && (
              <StagewiseToolbar 
                config={{
                  plugins: [ReactPlugin]
                }} 
              />
            )}
            </RoleProvider>
          </UserProvider>
          </SessionWorkspace>
        </Refine>
      </RefineKbarProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
